import { CenteredLoading, RestrictPlatform, twClassMerge } from '@healthhub/react-ui';
import { memo } from 'react';

import { envBaseUrl } from '@shared/configs/configs/config';
import { DEEP_LINKS } from '@shared/constants/deepLinks';
import { useLayoutViewContext } from '@shared/context';
import useServiceCatalog from '@shared/hooks/useServiceCatalog';
import { useGetMobileAppBannerQuery } from '@shared/services/sitecore';

interface RestrictPlatformWrapperProps {
  children: React.ReactNode;
  serviceCatalogCode: string;
}

const RestrictPlatformWrapper = ({ children, serviceCatalogCode }: RestrictPlatformWrapperProps) => {
  const { isMobileView, isSharedServiceView, isStandardView, isPortalView } = useLayoutViewContext();
  const { getService, isLoading } = useServiceCatalog(!serviceCatalogCode);

  const serviceCatalog = getService(serviceCatalogCode);
  const isRestricted =
    (isMobileView && serviceCatalog?.RestrictPlatform === 'NATIVE') ||
    (isPortalView && serviceCatalog?.RestrictPlatform === 'WEB');

  // The mobile app banner is only shown below the restriction message in the portal view
  const { data: mobileAppBanner, isLoading: isMobileAppBannerLoading } = useGetMobileAppBannerQuery(undefined, {
    skip: !isRestricted || !isPortalView,
  });

  if (isLoading) {
    return (
      <div
        className={twClassMerge(
          'h-full',
          (isMobileView || isStandardView || isSharedServiceView) && 'h-dvh -mt-mobileHeader'
        )}
      >
        <CenteredLoading fullScreen={false} />
      </div>
    );
  }

  if (!isRestricted) {
    return children;
  }

  return (
    <RestrictPlatform
      deepLinkUrl={`${envBaseUrl()}${DEEP_LINKS.openApp}`}
      isRestricted={isRestricted}
      layoutView={{ isMobileView }}
      mobileAppBannerProps={{ data: mobileAppBanner, isLoading: isMobileAppBannerLoading }}
    />
  );
};

export default memo(RestrictPlatformWrapper);
